Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _contentWidth = _styles.STYLES.grid.maxColumnWidth;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    viewports = _STYLES$useStyles.viewports,
    container = _STYLES$useStyles.container;
  var breakpoint = bp.gt(viewports.mobile_l);
  var row = {
    flex: 1,
    flexDirection: 'column'
  };
  if (breakpoint) {
    row.alignItems = 'flex-start';
    row.flexDirection = 'row';
  }
  var about = {
    flex: 1
  };
  var stats = {
    flex: 1,
    justifyContent: 'flex-end'
  };
  if (breakpoint) {
    stats.maxWidth = (0, _styles.getREM)(18.125);
  }
  var content = {
    maxWidth: _contentWidth,
    alignSelf: 'center',
    width: '100%'
  };
  var cta = {
    flex: 1,
    flexGrow: 1,
    backgroundColor: 'red',
    flexShrink: 0
  };
  var carousels = {
    paddingBottom: spacing.xxl,
    borderBottomColor: COLORS.silver,
    borderBottomWidth: 1
  };
  var header = {
    paddingBottom: spacing.xxxl
  };
  var headerContent = {
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(_contentWidth, " + ").concat(spacing.page.padding.paddingRight, " + ").concat(spacing.page.padding.paddingLeft, ")") : _contentWidth + spacing.page.padding.paddingRight + spacing.page.padding.paddingLeft,
    alignSelf: 'center',
    width: '100%'
  };
  var improvements = {
    flexDirection: 'column'
  };
  var improvementsHeading = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal,
    marginBottom: spacing.xs,
    color: COLORS.aubergine
  });
  var improvementItem = {
    flexDirection: 'row',
    alignItems: 'center'
  };
  var improvementItemText = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.brand
  });
  var dot = {
    width: 16,
    height: 16,
    borderRadius: 16,
    marginRight: spacing.s
  };
  var where = {
    flexDirection: breakpoint ? 'row' : 'column',
    alignItems: breakpoint ? 'center' : 'flex-start'
  };
  var whereHeading = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal,
    color: COLORS.aubergine
  });
  var tags = {
    flexDirection: 'row'
  };
  var sectionContainer = {
    marginBottom: spacing.xxl
  };
  var H3 = {
    marginBottom: spacing.m
  };
  var summaryText = Object.assign({}, fontSemiBold, {
    color: COLORS.aubergine
  });
  var summaryTextContainer = {
    marginBottom: breakpoint ? spacing.xl : spacing.normal
  };
  var descriptionText = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  });
  var descriptionTextContainer = {
    marginBottom: 0
  };
  var mainHeading = {
    marginBottom: breakpoint ? spacing.xl : spacing.normal
  };
  var styles = _reactNative.StyleSheet.create({
    row: row,
    about: about,
    stats: stats,
    container: container,
    content: content,
    cta: cta,
    carousels: carousels,
    header: header,
    headerContent: headerContent,
    improvements: improvements,
    improvementsHeading: improvementsHeading,
    improvementItem: improvementItem,
    improvementItemText: improvementItemText,
    dot: dot,
    where: where,
    whereHeading: whereHeading,
    tags: tags,
    H3: H3,
    sectionContainer: sectionContainer,
    summaryText: summaryText,
    summaryTextContainer: summaryTextContainer,
    descriptionText: descriptionText,
    descriptionTextContainer: descriptionTextContainer,
    mainHeading: mainHeading
  });
  return {
    styles: styles,
    breakpoint: breakpoint
  };
};